<template>
  <div class="privacyPolicy">
    <!-- <Navbar :backNative="true" title="" /> -->
    <div class="title">{{ detail.name }}</div>
    <div class="richText" v-html="detail.content"></div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
export default {
  data() {
    return {
      detail: {}, //富文本
    };
  },
  components: {
    //   Navbar
  },
  mounted() {
    this.$nextTick(() => {
      http.getPrivacyPolicy({ type: 1 }).then((res) => {
        this.detail = res;
      });
    });
  },
  methods: {
    initPage() {
      http.getPrivacyPolicy({ type: 1 }).then((res) => {
        this.detail = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.privacyPolicy {
  .richText {
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 12px;
    /deep/ img {
      max-width: 100%;
    }
  }
  .title {
    font-size: 18px;
    color: #222030;
    font-weight: 600;
    margin-top: 21px;
    padding: 0 16px;
    box-sizing: border-box;
  }
}
</style>
